<template>
    <b-modal
        id="organizationStatistics"
        title="Histórico de Alunos"
        size="xl"
        no-close-on-backdrop
        hide-footer>
        <b-overlay :show="loading" rounded="sm">

            <div class="d-flex mb-3">
                <b-form-group class="mr-3"
                    label="Data Início">

                    <b-form-datepicker v-model="form.dateFrom" locale="pt" @input="load(organizationId)"></b-form-datepicker>

                </b-form-group>

                <b-form-group
                    label="Data Final">

                    <b-form-datepicker v-model="form.dateTo" locale="pt" @input="load(organizationId)"></b-form-datepicker>

                </b-form-group>

            </div>

            <GChart
                type="AreaChart"
                :settings="{packages: ['corechart'], language: 'pt-br'}"
                :data="statistics"
                :options="chartOptions"
            />
        </b-overlay>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            organizationId: null,
            statistics: [],
            form: {
                dateFrom: null,
                dateTo: null
            },
            chartOptions: {
                fontName: 'Inter',
                height: 600,
                legend: {
                    position: 'top',
                    maxLines: 3
                },
            }
        }
    },
    created() {
        this.$root.$on('showStatistics', (organizationId) => {

            this.form = {
                dateFrom: null,
                dateTo: null
            };

            this.statistics = [];

            this.organizationId = organizationId;
            this.$bvModal.show('organizationStatistics');
            this.load(organizationId);
        })
    },
    methods: {
        load(organizationId) {
            this.loading = true;
            axios.get('/admin/organizations/' + organizationId + '/statistics', {
                params: {
                    ...this.form
                }
            })
                .then((result) => {
                    this.statistics = result.data.data;
                })
                .finally(() => this.loading = false)
        }
    }
}
</script>

<style scoped>

</style>
